export const createRoundedRectangleGeometry = (options: {
  width: number;
  height: number;
  borderRadius: number;
  THREE: any;
}) => {
  const { width, height, borderRadius, THREE } = options;
  const shape = new THREE.Shape();
  shape.moveTo(borderRadius, height);
  shape.lineTo(width - borderRadius, height);
  shape.quadraticCurveTo(width, height, width, height - borderRadius);

  shape.lineTo(width, borderRadius);
  shape.quadraticCurveTo(width, 0, width - borderRadius, 0);
  shape.lineTo(borderRadius, 0);
  shape.quadraticCurveTo(0, 0, 0, borderRadius);
  shape.lineTo(0, height - borderRadius);
  shape.quadraticCurveTo(0, height, borderRadius, height);
  return new THREE.ShapeGeometry(shape);
};

export const createHalfRoundedRectangleGeometry = (options: {
  width: number;
  height: number;
  borderRadius: number;
  THREE: any;
}) => {
  const { width, height, borderRadius, THREE } = options;
  const shape = new THREE.Shape();
  shape.moveTo(0, height);
  shape.lineTo(width, height);

  shape.lineTo(width, borderRadius);
  shape.quadraticCurveTo(width, 0, width - borderRadius, 0);
  shape.lineTo(borderRadius, 0);
  shape.quadraticCurveTo(0, 0, 0, borderRadius);
  shape.lineTo(0, height);
  return new THREE.ShapeGeometry(shape);
};

export const createRoundedRectangleMesh = (options: {
  width: number;
  height: number;
  borderRadius: number;
  color: string;
  isHalfRounded?: boolean;
  THREE: any;
}) => {
  const { width, height, color, isHalfRounded, THREE } = options;
  const geometry = isHalfRounded
    ? createHalfRoundedRectangleGeometry(options)
    : createRoundedRectangleGeometry(options);
  const material = new THREE.MeshBasicMaterial({
    side: THREE.DoubleSide,
    color,
  });
  const mesh = new THREE.Mesh(geometry, material);
  const pivot = new THREE.Group();

  mesh.position.x = -width / 2;
  mesh.position.y = -height / 2;
  pivot.add(mesh);
  return pivot;
};

export const createTriangleGeometry = (options: { width: number; height: number; THREE: any }) => {
  const { width, height, THREE } = options;

  const shape = new THREE.Shape();
  shape.moveTo(0, height);
  shape.lineTo(width, height);
  shape.lineTo(width / 2, 0);
  shape.lineTo(0, height);
  return new THREE.ShapeGeometry(shape);
};

export const createTriangleMesh = (options: {
  width: number;
  height: number;
  color: string;
  THREE: any;
}) => {
  const { width, height, color, THREE } = options;
  const geometry = createTriangleGeometry(options);
  const material = new THREE.MeshBasicMaterial({
    side: THREE.DoubleSide,
    color,
  });
  const mesh = new THREE.Mesh(geometry, material);
  const pivot = new THREE.Group();

  mesh.position.x = -width / 2;
  mesh.position.y = -height / 2;
  pivot.add(mesh);
  return pivot;
};

export const crop = (can, x, y, w, h) => {
  // get your canvas and a context for it
  const ctx = can.getContext('2d');

  // get the image data you want to keep.
  const imageData = ctx.getImageData(x, y, w * 2, h);

  // create a new cavnas same as clipped size and a context
  const newCan = document.createElement('canvas');
  newCan.width = w - x;
  newCan.height = h - y;
  const newCtx = newCan.getContext('2d');

  if (!newCtx) return;
  // put the clipped image on the new canvas.
  newCtx.putImageData(imageData, 0, 0);

  return newCan;
};

export const roundRect = (ctx, x, y, w, h, r) => {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
};
